import { _ as __read, a as __spreadArray } from '../../../_tslib-7a01aab4.js';
import React, { useState, useCallback } from 'react';

/**
 * @name Accordion
 * @param multiple
 * @param onScroll
 * @param firstOpen
 * @param restProps
 */
var Accordion = function (_a) {
    var multiple = _a.multiple, onScroll = _a.onScroll, _b = _a.firstOpen, firstOpen = _b === void 0 ? true : _b, children = _a.children;
    var _c = __read(useState(function () {
        return !(openedItem === null || openedItem === void 0 ? void 0 : openedItem.length) && firstOpen ? [0] : [];
    }), 2), openedItem = _c[0], setOpenedItem = _c[1];
    var handleOpenAccordionItem = useCallback(function (id) {
        if (multiple) {
            setOpenedItem(function (o) { return __spreadArray(__spreadArray([], __read(o), false), [id], false); });
        }
        else {
            setOpenedItem([id]);
        }
    }, [setOpenedItem, multiple]);
    var handleRowClick = useCallback(function (id) {
        var rowIndex = openedItem.indexOf(id);
        if (rowIndex !== -1) {
            var data = openedItem;
            data.splice(rowIndex, 1);
            setOpenedItem(__spreadArray([], __read(data), false));
        }
        else {
            handleOpenAccordionItem(id);
        }
    }, [openedItem]);
    return (React.createElement("div", { className: 'scroll-holder' },
        React.createElement("div", { className: 'scrollable-container', onScroll: onScroll }, React.Children.map(children, function (element, index) {
            return React.cloneElement(element, {
                onRowClick: handleRowClick,
                openedItem: openedItem,
                index: index,
            });
        }))));
};

export { Accordion };
